// Pure helpers for the saved-plan "Replace Both" dialog (PairSwapDialog).
// Extracted so the authoritative-cook resolution and the server-rejection message
// mapping can be regression-tested without rendering the dialog.

// Resolve the AUTHORITATIVE pair identity from the caller's known rows: the swap
// must always target the COOK row's plan_id (regardless of which card opened the
// dialog). Falls back to the provided context when rows are not yet known.
export function resolvePairSwapContext(pairRows, context) {
  var rows = pairRows || [];
  var cookRow = rows.find(function (m) { return m.leftover_role === 'cook'; });
  var leftoverRow = rows.find(function (m) { return m.leftover_role === 'leftover'; });
  return {
    groupId: context.groupId,
    planId: cookRow ? cookRow.plan_id : context.planId,
    cookDate: cookRow ? cookRow.date : context.date,
    leftoverDate: leftoverRow ? leftoverRow.date : null,
    currentMealId: cookRow ? cookRow.meal_id : (rows[0] && rows[0].meal_id),
  };
}

// Map a backend swap-pair rejection to a safe user message WITHOUT leaking raw
// server text. Every known reject reason is handled explicitly so a failed swap
// never looks like a success.
export function pairSwapErrorMessage(detail) {
  var code = (detail && typeof detail === 'object') ? detail.error : detail;
  if (code === 'stale_state') return 'This plan changed — please reopen and try again';
  if (code === 'invalid_group') return "This linked pair is invalid and can't be swapped";
  if (code === 'leftover_finalized' || code === 'use_child_swap' || code === 'row_replaced') {
    return "One of these meals is already done — it can't be replaced";
  }
  return 'Failed to replace the linked meals';
}
